(function () {
    'use strict';

    angular
        .module('Lavpop-store.components')
        .controller('OrderFinalizationController', OrderFinalizationController);

    /** @ngInject */
    function OrderFinalizationController($rootScope, $state) {
        const vm = this;

        init();

        function init() {
            $rootScope.addDivisor = true;

            vm.orderId = $rootScope.orderId;
            vm.warningMessages = angular.isArray($rootScope.orderWarningMessages) ? $rootScope.orderWarningMessages : [];
            $rootScope.orderWarningMessages = [];

            if (!vm.orderId)
                $state.go('app.products');
        }
    }
}());